<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcTurnoverForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            otherFeature: false,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
        this.otherFeature = Boolean(this.model.$.feature_other);
        this.handlePlannedMonthlyOperation();
    },

    watch: {
        otherFeature(value) {
            if (!this.model) {
                return;
            }

            if (!value) {
                this.model.feature_other = '';
            }
        },

        'model.$.features': 'handlePlannedMonthlyOperation',

        'model.$.create_union_payment_account'(value) {
            if (!this.model) {
                return;
            }

            if (!value) {
                this.model.$.create_union_account = 0;
            }
        },
    },

    methods: {
        handlePlannedMonthlyOperation() {
            if (!this.isCashOperationsSelected && this.model.$.zero_eur_amount_id) {
                this.model.$.planned_monthly_operation_id = this.model.$.zero_eur_amount_id;
            }
        },

        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', Object.assign({ use_feature_other: Number(this.otherFeature) }, this.model.$));
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },

    computed: {
        isCashOperationsSelected() {
            if (!this.model || !this.model.$.cash_operations_feature_id) {
                return true;
            }

            return this.model.$.features?.includes(this.model.$.cash_operations_feature_id);
        },
    },
};
</script>
